<template>
    <path d="M6.5 7.375H3.437c-.118 0-.22.043-.307.13-.087.086-.13.19-.13.308v8.75c0 .118.043.22.13.307.086.087.19.13.308.13H6.5c.118 0 .22-.043.308-.13.086-.086.13-.19.13-.308v-8.75c0-.118-.044-.22-.13-.307-.087-.087-.19-.13-.308-.13zm-.438 8.75H3.876V8.25h2.188v7.875zm5.25-6.152H8.25c-.128 0-.232.043-.314.13-.082.086-.123.19-.123.307v6.152c0 .12.04.222.123.308.082.087.186.13.314.13h3.063c.118 0 .22-.043.307-.13.087-.086.13-.19.13-.308V10.41c0-.118-.043-.22-.13-.307-.086-.087-.19-.13-.307-.13zm-.437 6.152H8.687v-5.277h2.188v5.277zM16.125 3h-3.063c-.118 0-.22.043-.307.13-.087.086-.13.19-.13.308v13.124c0 .12.043.222.13.308.086.087.19.13.307.13h3.063c.118 0 .22-.043.308-.13.086-.086.13-.19.13-.308V3.438c0-.118-.044-.22-.13-.307-.087-.085-.19-.13-.308-.13zm-.438 13.125H13.5V3.875h2.188v12.25z"/>
</template>

<script>
export default {
    name: 'totalsBarsIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 20 20');
    }
};
</script>
